import { render, staticRenderFns } from "./CardCountdownWinNumber.vue?vue&type=template&id=06fe8840&lang=pug"
import script from "./CardCountdownWinNumber.vue?vue&type=script&lang=js"
export * from "./CardCountdownWinNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports